window.SUB = window.SUB || {};

SUB.recipe_landing = {
	init : function(){
		var $carousel = $("#header-carousel");
		<!-- init header carousel -->
//		$carousel.imagesLoaded(function(){
//			$carousel.owlCarousel({
//				items : 1,
//				singleItem : true,
//				autoPlay : true,
//				stopOnHover : true
//			});
//		});

		// set up social sharing on carousel slides
		SUB.recipe_shared.social();

		// set up ratings on carousel slides
		SUB.recipe_shared.voting();

		// set up searchfield to clear/replace text on focus
		var $searchfield = $("#search").find("input.input"),
			inputText = $searchfield.val();

		$searchfield.on('focus',function(){
			if ($searchfield.val() === inputText){
				$searchfield.val('');
			}
		});
		$searchfield.on('blur',function(){
			if ($searchfield.val() == ''){
				$searchfield.val(inputText);
			}
		});
	}
};

SUB.recipe_detail = {
	init : function(){
			// set up social sharing on carousel slides
		SUB.recipe_shared.social();

		// set up ratings on carousel slides
		SUB.recipe_shared.voting();


		// set up video player and overlay, if necessary
		SUB.videoPrep.init();
	}
};


// common items between landing and detail: voting, social
SUB.recipe_shared = {

	social : function(){
	// structure of parent container:
	//<div class="social_share"
	//      data-recipe-name="Recipe Title"
	//      data-recipe-url="/recipes/recipetitle"
	//      data-recipe-shareimg="imagename.jpg"
	//	>

		$('.social_share').each(function(){

			var $win = window,
				$shareParent = $(this),
				urlPrefix = $win.location.protocol + '//' + $win.location.host,
				imgPrefix = urlPrefix + '/Content/img/social_sharing/facebook/',
				recipeName = $shareParent.attr('data-recipe-name'),
				recipeURL = urlPrefix + $shareParent.attr('data-recipe-url'),
				recipeImg = $shareParent.attr('data-recipe-shareimg'),
				encodedRecipeURL =  encodeURIComponent(recipeURL),
				ingredientString = $shareParent.attr('data-ingredient-string'),
				tipString = $shareParent.attr('data-tip-string'),

			// default social sharing text
				$twitter = $shareParent.find('.twitter'),
				$facebook = $shareParent.find('.facebook'),
				$pinterest = $shareParent.find('.pinterest'),

				bitlyLink = $shareParent.attr('data-bitly-link'),
				defaultString =  'Oh my yum! Break free from the box with this ' + recipeName,
				defaultDescription = 'Stir up breakfast with simple and fun cereal recipes',

				fbURL = recipeURL,
				fbName =  defaultString + ' breakfast idea',
				fbCaption = defaultDescription,
				fbImage = imgPrefix + recipeImg,

				tweetString = defaultString + ' recipe. #StirUpBreakfast ',


				pinterestURL = encodedRecipeURL,
				pinterestImage = fbImage,
				pinterestString = defaultString + ' breakfast idea. #StirUpBreakfast ' + recipeURL + ' You’ll need ' + ingredientString + '. Tip: ' + tipString;
			// create recipe FB buttons
			$facebook.click(function(e){
				e.preventDefault();
				dataLayer.push({event: 'event', category: 'stir_up_your_bowl', action: 'social share', label: 'social_share-facebook'});

				FB.ui({
					method: 'feed',
					name: fbName,
					link: fbURL,
					caption: fbURL,
					description: fbCaption,
					picture : fbImage
				}, function(response){//console.log('facebooked!')
				});


			});
			// Update twitter with dynamic tweet string
			$twitter.attr('data-url', bitlyLink).attr('data-text', tweetString);

			// create recipe pinterest button url
			pinterestURL = '//www.pinterest.com/pin/create/button/?url=' + pinterestURL + '&media=' + encodeURIComponent(pinterestImage) + '&description=' + encodeURIComponent(pinterestString);
			$pinterest.attr('href', pinterestURL);

		});
	},
	voting : function(){
		$('.vote').each(function(){

			var $voteParent = $(this),
				recipeID = $voteParent.attr('data-recipe-id'),
			    $thumbsUp = $voteParent.find('.thumbs_up'),
				$thumbsDown = $voteParent.find('.thumbs_down');
			// bind voting buttons
			// thumbs up
			$thumbsUp.click(function(e){
				e.preventDefault();
				updateCount($voteParent, recipeID, 1);
			});

			// thumbs down
			$thumbsDown.click(function(e){
				e.preventDefault();
				updateCount($voteParent, recipeID, -1);
			});
		});
		
		function updateCount($voteParent, recipeID, rating){
			$.post("/recipe/TallyRating", {recipeID: recipeID, rating: rating},  function( data ) {
				var $votesUp = $voteParent.find('.thumbs_up_count'),
			    $votesDown = $voteParent.find('.thumbs_down_count');

				$votesUp.animate({'opacity': 0}, 100, function(){
					$votesUp.html(data.RatingUp);
					$votesUp.animate({'opacity': 1}, 100);
				});
				$votesDown.animate({'opacity': 0}, 100, function(){
					$votesDown.html(data.RatingDown);
					$votesDown.animate({'opacity': 1}, 100);
				});
			});
		};
	}
};

